/**
 * 生年月日（YYYY-MM-DD）から満年齢を求める。
 *
 * 年齢は誕生日をまたぐと変わるため DB には持たせず、表示のたびにここで計算する。
 * 形式が不正な値や未来日は年齢として意味がないので null を返す。
 */
export function calculateAge(birthDate: string | null | undefined, today: Date = new Date()): number | null {
  if (!birthDate || !/^\d{4}-\d{2}-\d{2}$/.test(birthDate)) return null

  const [year, month, day] = birthDate.split('-').map(Number)
  // 存在しない日付（2月30日など）は Date が繰り上げるので、往復させて弾く
  const birth = new Date(year, month - 1, day)
  if (birth.getFullYear() !== year || birth.getMonth() !== month - 1 || birth.getDate() !== day) return null

  let age = today.getFullYear() - year
  // 今年の誕生日がまだ来ていなければ 1 引く
  const beforeBirthday =
    today.getMonth() < month - 1 || (today.getMonth() === month - 1 && today.getDate() < day)
  if (beforeBirthday) age -= 1

  return age >= 0 ? age : null
}

/** ローカルタイムゾーンでの今日を YYYY-MM-DD で返す。日付入力の上限に使う */
export function todayIso(today: Date = new Date()): string {
  const year = today.getFullYear()
  const month = String(today.getMonth() + 1).padStart(2, '0')
  const day = String(today.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
